import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { NotificationConfig } from './service-notification.interfaces';

@Injectable()
export class ServerNotificationConfigService {

    constructor(private config: ConfigService) {
    }

    get NotificationConfig(): NotificationConfig {

        if (this.config.appConfig && this.config.appConfig.api.notificationUrl) {
            return {
                url: this.config.appConfig.api.notificationUrl,
                hubName: this.config.const.mcNotificationHub.labNotificationHub
            } as NotificationConfig;
        }

        return null;
    }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/server-notification/server-notification-config.service.ts